import React from "react";
import { Navigate } from "react-router-dom";
import { getRole } from "../../utils/auth";
import permissions from "../../utils/permissions";


const ProtectedRoute = ({ children, permission }) => {

  const token = sessionStorage.getItem("token");

  const role = getRole();


  // User not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }


  // Permission checking
  if(permission){

    const rolePermissions = permissions[role];


    const allowed = rolePermissions?.[permission];


    if(!allowed){

      return <Navigate to="/dashboard" replace />;

    }

  }


  return children;

};


export default ProtectedRoute;